// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.colors-row.absolute {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0 2px;
  max-width: 60%;
  text-align: end;
}

.colors-row.center {
  text-align: center;
  align-items: flex-start;
}

ion-card.disabled {
  opacity: 0.1;
}

ion-card {
  margin: 2px;
  cursor: pointer;
}
ion-card ion-card-header {
  border-bottom: 0.5px solid #e3e3e2;
  padding: 0;
  display: flex;
  font-size: 15px;
  justify-content: center;
  align-items: center;
}
ion-card ion-card-header ion-icon {
  background: var(--button-b-background);
  --color: var(--button-b-text);
  color: var(--button-b-text);
  border-radius: 30px;
  padding: 2px;
}
ion-card ion-card-content {
  padding: 5px;
  line-height: 0.8;
  white-space: pre-line;
  width: 60px;
  font-size: 11px;
}

.color-prop-box {
  height: 30px;
}

.color-prop-box.small {
  width: 23px;
  height: 23px;
}

.color-prop-box.disabled {
  opacity: 0.1;
}

.props-row {
  white-space: pre-line;
}

.prop-box {
  margin: 2px;
}

.prop-box.active, .color-prop-box.active {
  opacity: 0.7;
}

.prop-box.small {
  padding-inline-start: 6px;
  padding-inline-end: 6px;
  height: 22px;
}

.title-choose {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/item/components/item-props-view/item-props-view.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,uBAAA;AACF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,WAAA;EACA,eAAA;AAAF;AAEE;EACE,kCAAA;EACA,UAAA;EAEA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AADJ;AAGI;EACE,sCAAA;EACA,6BAAA;EACA,2BAAA;EAEA,mBAAA;EACA,YAAA;AAFN;AAKE;EACE,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;AAHJ;;AAOA;EAEE,YAAA;AALF;;AAsBA;EACE,WAAA;EACA,YAAA;AAnBF;;AAsBA;EACE,YAAA;AAnBF;;AAsBA;EAEE,qBAAA;AApBF;;AAuBA;EAEE,WAAA;AArBF;;AAwBA;EAEE,YAAA;AAtBF;;AAyBA;EAEE,yBAAA;EACA,uBAAA;EACA,YAAA;AAvBF;;AA0BA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;AAvBF","sourcesContent":[".colors-row.absolute {\n  position: absolute;\n  top: 0;\n  left: 0;\n  padding: 0 2px;\n  max-width: 60%;\n  text-align: end;\n}\n\n.colors-row.center {\n  text-align: center;\n  align-items: flex-start;\n}\n\n\nion-card.disabled {\n  opacity: 0.1;\n}\n\nion-card{\n  margin: 2px;\n  cursor: pointer;\n\n  ion-card-header{\n    border-bottom: 0.5px solid #e3e3e2;\n    padding: 0;\n\n    display: flex;\n    font-size: 15px;\n    justify-content: center;\n    align-items: center;\n\n    ion-icon {\n      background: var(--button-b-background);\n      --color: var(--button-b-text);\n      color: var(--button-b-text);\n\n      border-radius: 30px;\n      padding: 2px;\n    }\n  }\n  ion-card-content{\n    padding: 5px;\n    line-height: 0.8;\n    white-space: pre-line;\n    width: 60px;\n    font-size: 11px;\n  }\n}\n\n.color-prop-box {\n  //width: 15px;\n  height: 30px;\n  //border: 1px solid #000;\n  //display: inline-block;\n  //border-radius: 4px;\n  //margin: 3px 1px;\n\n}\n\n.color-prop-box.big {\n  //width: 30px;\n  //height: 30px;\n  //border: 1px solid #000;\n  //display: inline-block;\n  //border-radius: 10px;\n  //margin: 0 2px;\n}\n\n.color-prop-box.small {\n  width: 23px;\n  height: 23px;\n}\n\n.color-prop-box.disabled {\n  opacity: 0.1;\n}\n\n.props-row\n{\n  white-space: pre-line;\n}\n\n.prop-box\n{\n  margin: 2px;\n}\n\n.prop-box.active, .color-prop-box.active\n{\n  opacity: 0.7;\n}\n\n.prop-box.small\n{\n  padding-inline-start: 6px;\n  padding-inline-end: 6px;\n  height: 22px;\n}\n\n.title-choose{\n  font-size: 18px;\n  font-weight: bold;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
